import { render } from "./FilterATSalesmanDataSample.vue?vue&type=template&id=6fb1d044"
import script from "./FilterATSalesmanDataSample.vue?vue&type=script&lang=js"
export * from "./FilterATSalesmanDataSample.vue?vue&type=script&lang=js"
script.render = render

export default script